import { Tracker } from 'src/shared/tracker/Tracker';

import React, { useEffect, useRef, useState } from 'react';
import { Flex } from './UI/Flex';
import { Spinner } from './UI/Spinner';
import { sendEventOpenWhatsapp } from 'src/helpers/window';
import { isMobileApp } from 'src/helpers/isMobileApp';

export enum PRESCRIPTION_POST_MESSAGE_TYPES {
  cancel = 'cancel',
  excluded = 'excluded',
  prescricao = 'prescricao',
  whatsapp = 'whatsapp',
}

interface PrescriptionViewerProps {
  url: string;
  onClose(eventType: PRESCRIPTION_POST_MESSAGE_TYPES): void;
  isUserOnApp: boolean;
}

export function PrescriptionViewer(props: PrescriptionViewerProps) {
  const { url, onClose } = props;
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const handleIframeLoad = () => {
    setLoading(false);

    const workspaceBaseUrl = process.env.REACT_APP_WORKSPACE_BASEURL || '';

    // Envia mensagem via postMessage para o iframe para sinalizar se é dentro do app
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'SET_REACT_NATIVE_WEBVIEW',
          value: isMobileApp(),
        },
        workspaceBaseUrl
      );
    }
  };

  useEffect(() => {
    const eventListener = (event: any) => {
      const validEvents = ['cancel', 'excluded', 'prescricao', 'whatsapp'];
      if (validEvents.includes(event.data.type)) {
        const trackEventValue = event.data.type === 'excluded' ? 'Receita Cancelada' : 'Receita emitida';

        if (event.data.type === 'whatsapp' && props.isUserOnApp) {
          sendEventOpenWhatsapp(event.data.paramsUrl);
        }

        Tracker.trackEvent({
          event: trackEventValue,
          parameters: {
            data: new Date(),
            isOnApp: props.isUserOnApp,
          },
        });

        onClose(event.data.type);
      }
    };
    window.addEventListener('message', eventListener, false);
    return () => {
      window.removeEventListener('message', eventListener);
    };
  }, [onClose, props.isUserOnApp]);

  // Gerencia o botão voltar do navegador
  useEffect(() => {
    window.history.pushState({ prescriptionViewerOpen: true }, '');

    const handleBrowserGoBackWithModalOpen = (event: PopStateEvent) => {
      if (!event.state?.prescriptionViewerOpen) {
        window.history.pushState({ prescriptionViewerOpen: false }, '');
        onClose(PRESCRIPTION_POST_MESSAGE_TYPES.cancel);
      }
    };

    window.addEventListener('popstate', handleBrowserGoBackWithModalOpen);

    return () => {
      window.removeEventListener('popstate', handleBrowserGoBackWithModalOpen);
      if (window.history.state?.prescriptionViewerOpen === false) {
        window.history.back();
      }
    };
  }, [onClose]);

  return (
    <Flex flex={1} bg={'transparent'} padding={{ base: 0 }}>
      <Flex overflow={'hidden'} backgroundColor={'surface'} borderRadius={{ base: 0 }} flex={1}>
        {loading && (
          <Flex
            pos={'absolute'}
            top={0}
            right={0}
            bottom={0}
            left={0}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Spinner color={'primary.1000'} size="xl" />
          </Flex>
        )}

        <iframe
          ref={iframeRef}
          title="Mevo Prescritores"
          src={url}
          allow="microphone *;"
          style={{
            width: '100%',
            height: '100%',
            margin: 0,
            display: 'block',
            border: 'none',
          }}
          onLoad={handleIframeLoad}
        />
      </Flex>
    </Flex>
  );
}
